export const EXPENSES_TEXT = Object.freeze({
  page: {
    title: 'Gastos',
    subtitle: 'Gestión y seguimiento de gastos operativos.',
    confirm: {
      noProvider: 'Sin proveedor',
      noConcept: 'Sin concepto',
      delete: {
        title: 'Eliminar gasto',
        subtitle: 'Esta acción no se puede deshacer.',
        messageDefault: 'Confirma que deseas eliminar este gasto.',
        confirm: 'Eliminar',
        confirming: 'Eliminando...',
      },
      approve: {
        titleApprove: 'Aprobar gasto',
        titleUnapprove: 'No aprobar gasto',
        subtitleApprove: 'Confirma para marcar este gasto como aprobado.',
        subtitleUnapprove: 'Confirma para quitar la aprobación de este gasto.',
        messageApproveDefault: 'Confirma que deseas aprobar este gasto.',
        messageUnapproveDefault: 'Confirma que deseas no aprobar este gasto.',
        confirmApprove: 'Aprobar',
        confirmUnapprove: 'No aprobar',
        confirmingApprove: 'Aprobando...',
        confirmingUpdate: 'Actualizando...',
      },
      cancel: 'Cancelar',
      summary: ({ provider, concept, amount }) => `Proveedor: ${provider}\nConcepto: ${concept}\nMonto: ${amount}`,
    },
  },
  metrics: {
    latestMetaPrefix: 'Fecha de registro:',
    kpis: {
      total: 'Total de Gastos',
      pendingToPay: 'Pendiente a pagar',
      paid: 'Pagado',
      latest: 'Último gasto registrado',
    },
  },
  list: {
    status: {
      paid: 'Pagado',
      pending: 'Pendiente',
    },
    hasXml: {
      yes: 'Sí',
      no: 'No',
    },
  },
  toolbar: {
    searchPlaceholder: 'Buscar por proveedor, concepto o referencia',
    filtersButtonTitle: 'Filtros',
    searchButtonTitle: 'Buscar',
    emptyOption: 'Sin opción disponible',
    dateRangePresets: [
      { key: 'this_month', label: 'Este mes' },
      { key: 'last_month', label: 'Mes anterior' },
      { key: 'this_year', label: 'Año actual' },
      { key: 'last_year', label: 'Año anterior' },
    ],
    allOptionLabels: {
      provider: 'Proveedor: Todos',
    },
    selectionAllLabels: {
      provider: 'Proveedor: Todos',
    },
    filters: {
      provider: { label: 'Proveedor', placeholder: 'Selecciona proveedor', searchable: true },
      expenseClass: { label: 'Clase', placeholder: 'Selecciona clase', searchable: true },
      category: { label: 'Categoría', placeholder: 'Selecciona categoría', searchable: true },
      customer: { label: 'Cliente', placeholder: 'Selecciona cliente', searchable: true },
      tags: { label: 'Etiquetas', placeholder: 'Selecciona etiquetas', searchable: true },
      hasXml: { label: 'Tiene XML', placeholder: 'Selecciona opción', searchable: false },
      currency: { label: 'Moneda', placeholder: 'Selecciona moneda', searchable: true },
      area: { label: 'Área', placeholder: 'Selecciona área', searchable: true },
    },
  },
  table: {
    loading: 'Cargando gastos...',
    empty: 'Sin gastos disponibles para los filtros seleccionados.',
    sortTitles: {
      date: 'Ordenar por fecha',
      provider: 'Ordenar por proveedor',
      subtotal: 'Ordenar por subtotal',
      total: 'Ordenar por total',
      paymentDate: 'Ordenar por fecha de pago',
    },
    columns: {
      date: 'FECHA',
      provider: 'PROVEEDOR',
      category: 'CATEGORÍA',
      concept: 'CONCEPTO',
      business: 'NEGOCIO',
      subtotal: 'SUBTOTAL',
      taxes: 'IMPUESTOS',
      total: 'TOTAL',
      paymentDate: 'FECHA PAGO',
      status: 'ESTADO',
      reference: 'REFERENCIA',
    },
    links: {
      providerDetail: 'Ir al detalle del proveedor',
      customerDetail: 'Ir al detalle del cliente',
      saleDetail: 'Ir al detalle del negocio',
    },
    actions: {
      edit: 'Editar',
      unapprove: 'No aprobar',
      delete: 'Eliminar',
      more: 'Más acciones',
      downloadXml: 'Descargar xml',
      downloadPdf: 'Descargar pdf',
      downloadReceipt: 'Descargar comprobante',
    },
  },
  flow: {
    errors: {
      save: 'No fue posible guardar el gasto.',
      detail: 'No fue posible cargar el detalle del gasto.',
      payIdentify: 'No fue posible identificar el gasto a pagar.',
      paySave: 'No fue posible registrar el pago del gasto.',
      delete: 'No fue posible eliminar el gasto.',
      approve: 'No fue posible actualizar la aprobación del gasto.',
    },
    success: {
      create: 'Gasto guardado correctamente.',
      update: 'Gasto actualizado correctamente.',
      pay: 'Pago de gasto registrado correctamente.',
      delete: 'Gasto eliminado correctamente.',
      approve: 'Gasto aprobado correctamente.',
      unapprove: 'Gasto actualizado a no aprobado.',
    },
    pending: {
      referencePrefix: 'Gasto',
      suffix: 'estará disponible pronto.',
      actions: {
        pay: 'Pagar',
        approve: 'Aprobar',
        delete: 'Eliminar',
        downloadXml: 'Descarga XML de',
        downloadPdf: 'Descarga PDF de',
        downloadReceipt: 'Descarga comprobante de',
      },
    },
  },
  modal: {
    closeAriaLabel: 'Cerrar modal',
    sectionsAriaLabel: 'Secciones del formulario de gasto',
    titleCreate: 'Nuevo gasto',
    titleEdit: 'Editar gasto',
    subtitleCreate: 'Captura rápida para registrar un gasto.',
    subtitleEdit: 'Actualiza la información del gasto seleccionado.',
    cancel: 'Cancelar',
    submitCreate: 'Guardar',
    submitEdit: 'Actualizar',
    submitting: 'Guardando...',
    sections: {
      general: {
        title: 'Información general',
        description: 'Comprobante, montos, impuestos y proveedor.',
      },
      operational: {
        title: 'Gestión operativa',
        description: 'Folio, fechas, cliente y negocio asociado.',
      },
      details: {
        title: 'Detalles',
        description: 'Etiquetas, área y comentarios internos.',
      },
      files: {
        title: 'Archivos',
        description: 'Adjuntos del gasto y evidencia documental.',
      },
    },
    validation: {
      supplierRequired: 'Selecciona un proveedor.',
      conceptRequired: 'Captura el concepto del gasto.',
      amountInvalid: 'El monto debe ser mayor a 0.',
      recurringCountInvalid: 'La cantidad de gastos debe ser mayor a 0.',
      firstInstallmentRequired: 'Selecciona la primera mensualidad.',
      periodicityRequired: 'Selecciona la periodicidad del gasto.',
    },
    warnings: {
      discountReset: 'No se puede capturar un descuento mayor al monto. Se restableció a 0.',
      deductionsReset: 'No se puede capturar deducciones mayores al monto. Se restableció a 0.',
    },
    supplierInline: {
      requiresClassCategory: 'Selecciona clase y categoría para crear el proveedor.',
      createError: 'No fue posible crear el proveedor.',
    },
    selectOptions: {
      documentTypes: {
        cfdi: 'CFDI',
        simpleNote: 'Nota simple',
        foreignReceipt: 'Comprobante extranjero',
        payroll: 'Nómina',
      },
    },
    statusLabels: {
      notApproved: 'No aprobado',
      pending: 'Pendiente',
      paid: 'Pagado',
      canceled: 'Cancelado',
    },
    fallbackSaleLabel: ({ id }) => `Negocio #${id}`,
  },
  sections: {
    common: {
      noOption: 'Sin opción disponible',
      today: 'Hoy',
    },
    sharedOperational: {
      title: 'Gestión Operativa',
      subtitle: 'Folio, fechas y relación con cliente o negocio.',
      folio: 'Folio',
      cfdiDate: 'Fecha CFDI',
      customer: 'Cliente',
      sale: 'Negocio',
      placeholders: {
        folio: 'Folio',
        date: 'Selecciona fecha',
        customer: 'Selecciona cliente',
        sale: 'Selecciona negocio',
      },
    },
    sharedDetails: {
      title: 'Detalles',
      subtitle: 'Organiza el gasto con etiquetas, área y notas internas.',
      entityLabel: 'gasto',
      tags: 'Etiquetas',
      area: 'Área',
      comments: 'Comentarios',
      placeholders: {
        tags: 'Selecciona etiquetas',
        area: 'Selecciona área',
        comments: 'Comentarios del gasto',
      },
    },
    sharedFiles: {
      title: 'Archivos',
      subtitle: 'Adjunta documentos del gasto para referencia y validación.',
      entityLabel: 'gasto',
      invoiceFiles: 'Factura (PDF y XML)',
      voucher: 'Comprobante',
      purchaseOrder: 'Orden de compra',
      additionalFile: 'Archivo adicional',
      additionalModeFile: 'Archivo',
      additionalModeUrl: 'URL',
      selectFile: 'Seleccionar archivo',
      noFile: 'Ningún archivo seleccionado',
      placeholders: {
        additionalUrl: 'https://...',
      },
    },
    general: {
      title: 'Información general',
      subtitle: 'Configuración del comprobante, proveedor, impuestos y montos.',
      statusPrefix: 'Estado:',
      statusHelper: 'Este campo se actualiza automáticamente según el flujo del gasto.',
      voucherType: 'Tipo de comprobante',
      supplier: 'Proveedor',
      supplierName: 'Nombre del proveedor',
      supplierContributor: 'Dato de facturación del proveedor',
      amountsTitle: 'Importes del gasto',
      amountsSubtitle: 'Montos base, descuentos y resumen de impuestos.',
      frequencyTitle: 'Frecuencia del gasto',
      expensesCount: 'Cantidad de gastos',
      firstInstallment: 'Primer mensualidad',
      periodicity: 'Periodicidad del gasto',
      total: 'Total',
      discount: 'Descuento',
      deductions: 'Deducciones',
      buttons: {
        hide: 'Ocultar',
        newSupplier: '+ Nuevo proveedor',
        cancel: 'Cancelar',
        saveAndUseSupplier: 'Guardar y usar proveedor',
      },
      placeholders: {
        supplier: 'Selecciona proveedor',
        supplierName: 'Nombre del proveedor',
        supplierContributor: 'Selecciona dato de facturación',
        firstInstallment: 'Selecciona mes',
        periodicity: 'Selecciona periodicidad',
        expensesCount: '1',
      },
      frequencyOptions: {
        unique: 'Único',
        monthly: 'Mensual',
        multiple: 'Múltiple',
      },
      defaultPendingStatus: 'Pendiente',
    },
    taxes: {
      title: 'Impuestos',
      subtitle: 'Selecciona el tipo de impuestos aplicables para este gasto.',
      withoutTaxes: 'Sin impuestos',
      taxType: 'Tipo de impuestos',
      taxes: 'Impuestos',
      placeholders: {
        taxes: 'Selecciona impuestos',
        group: 'Selecciona grupo',
      },
      fallbackTaxLabel: ({ id }) => `Impuesto #${id}`,
      fallbackGroupLabel: 'Grupo',
      fallbackGroupWithIdLabel: ({ id }) => `Grupo #${id}`,
      fallbackIndividualLabel: 'Individual',
    },
    totals: {
      subtotal: 'Subtotal',
      transferred: 'Trasladados',
      withheld: 'Retenciones',
      total: 'Total',
    },
    schedule: {
      expenseDate: 'Fecha del gasto',
      paymentDate: 'Fecha de pago',
      concept: 'Concepto',
      placeholders: {
        date: 'Selecciona fecha',
        concept: 'Concepto del gasto',
      },
    },
  },
});
